import reportSearchUnitBehaviorsRedux from '../../views/report/redux/slice';
import reportBehaviorAdvanceFilterRedux from '../../views/report/modals/filter/redux/slice';
import reportExportBehaviorsRedux from '../../views/report/modals/export/redux/slice';

export default {
    reportSearchUnitBehaviorsRedux,
    reportBehaviorAdvanceFilterRedux,
    reportExportBehaviorsRedux,
};
